import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "16",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17 14.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m1.5-9L20.46 8H16V5.5m-11 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M19 4h-3V0H2C.89 0 0 .89 0 2v11h2a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h2V8z" }, null, -1)
  ]))]))
}
export default { render: render }